import axiosCall from './interceptor';
import URL from '../helper';

export const getAllImages = async data => {
  const queryParams = Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&');
  const url = `${URL.BASE_URL}images?${queryParams}`;
  let response = await axiosCall('get', url);
  return response.data;
};
